// extracted by mini-css-extract-plugin
export var active = "_bk-7";
export var container = "_bk-0";
export var evenWidth = "_bk-4";
export var large = "_bk-5";
export var outlet = "_bk-8";
export var slide = "_bk-2";
export var small = "_bk-6";
export var tab = "_bk-3";
export var tabs = "_bk-1";